import React, { useState } from 'react'
import _ from 'lodash'
import ReactSelect from 'react-select'
import ReactSelectCreatable from 'react-select/creatable'

let styles = ({ hasError }) => ({
  singleValue: base => ({
    ...base,
    color: 'var(--gray-dark)',
  }),
  control: (base, state) => ({
    ...base,
    // sheesh, what a mess: https://stackoverflow.com/questions/52614304/react-select-remove-focus-border
    boxShadow: state.isFocused ? 0 : 0,
    backgroundColor: state.isDisabled ? 'var(--gray-100)' : undefined,
    borderColor: state.isFocused
      ? 'var(--primary)'
      : hasError
      ? 'var(--danger)'
      : 'var(--gray-400)',
    '&:hover': {
      borderColor: state.isFocused
        ? 'var(--primary)'
        : hasError
        ? 'var(--danger)'
        : 'var(--gray-400)',
    },
  }),
})

let SelectWithSelectAll = ({
  value,
  disabled,
  hasError,
  selectAllValue = '<__SOME SELECT ALL VALUE__>', // used like an ID so make it unique/cockeyed like this
  renderSelectAllOption = () => (
    <span>
      <i className="fa fa-check-square mr-2" />
      Select All
    </span>
  ),
  getRef = _.noop,
  options: initialOptions,
  onChange,
  getOptionLabel,
  ...props
}) => {
  let [menuIsOpen, setMenuIsOpen] = useState(false)
  let val = _.isArray(value) && !!value ? value : [value]
  let options = initialOptions

  if (selectAllValue && initialOptions.length !== value.length) {
    options = [selectAllValue].concat(initialOptions)
  }

  return (
    <ReactSelect
      ref={getRef}
      isMulti
      menuIsOpen={menuIsOpen}
      closeMenuOnSelect={false}
      isDisabled={disabled}
      className="col px-0"
      value={val}
      onMenuOpen={() => setMenuIsOpen(true)}
      onMenuClose={() => setMenuIsOpen(false)}
      onChange={newValue => {
        if (newValue.includes(selectAllValue)) {
          setMenuIsOpen(false)
          onChange(initialOptions)
        } else {
          onChange(newValue)
        }
      }}
      getOptionValue={v => v}
      styles={styles({ hasError })}
      placeholder="-- Select --"
      options={options}
      getOptionLabel={value =>
        value === selectAllValue
          ? renderSelectAllOption()
          : getOptionLabel(value)
      }
      {...props}
    />
  )
}

let Select = ({
  value,
  disabled,
  hasError,
  getRef = _.noop,
  showSelectAll,
  ...props
}) => {
  let val = _.isArray(value) && !!value ? value : [value]

  if (showSelectAll) {
    return (
      <SelectWithSelectAll
        {...{ value, disabled, hasError, getRef, ...props }}
      />
    )
  }

  return (
    <ReactSelect
      ref={getRef}
      isDisabled={disabled}
      className="col px-0"
      value={val}
      getOptionValue={v => v}
      styles={styles({ hasError })}
      placeholder="-- Select --"
      {...props}
    />
  )
}

export const SelectSimple = ({
  value,
  disabled,
  hasError,
  options,
  onChange,
  getRef = _.noop,
  ...props
}) => {
  return (
    <ReactSelect
      isDisabled={disabled}
      ref={getRef}
      className="col px-0"
      value={{
        value,
        label: _.chain(options).find({ value }).get('label').value(),
      }}
      styles={styles({ hasError })}
      placeholder="-- Select --"
      {...props}
      options={options}
      onChange={({ value }) => onChange(value)}
    />
  )
}

export let SelectCreatable = ({
  onChange,
  value,
  options,
  disabled,
  hasError = false,
  ...props
}) => {
  return (
    <ReactSelectCreatable
      isClearable
      isDisabled={disabled}
      onChange={onChange}
      formatCreateLabel={val => val}
      value={value}
      options={options}
      styles={styles({ hasError })}
      {...props}
    />
  )
}

export default Select
